<section class="fadein animation-duration-500 grid flex flex-column w-full p-5">
  <div class="col-12 flex flex-row align-items-center gap-2 m-2">
    <i class="pi pi-angle-left"></i>
    <p>
      <a href="javascript:void(0)" (click)="goBack()">Mis reclamos laborales</a>
    </p>
    <p>/</p>
    <p><a class="font-bold">Detalle del reclamo</a></p>
  </div>
  <div class="col-12 flex justify-content-between align-items-center">
    <span class="titleSection font-bold text-xl mt-2 mb-2">Detalle del reclamo</span>
    <p-button icon="pi pi-download" [style]="{ background: '#263245' }" label="Descargar"
      (click)="downloadAsPdf()"></p-button>
  </div>

  <section id="claim-view">
    <article class="col-12 flex align-items-start gap-3">
      <div class="col-12 md:col-6 shadow-2 p-4 border-round-sm m-0">
        <div class="flex justify-content-between align-items-center">
          <span class="titleSection font-medium text-lg">Número de reclamo: {{ claim?.numberOfClaim }}</span>
          <p [ngClass]="getStatusClass(claim?.status)">
            {{ claim?.status! | claimStatusDisplay }}
          </p>
        </div>
        <p>Fecha de inicio: {{ claim?.startDate | date : "dd/MM/yyyy" }}</p>
        <p>
          Departamento:
          <span class="bold">{{
            departamentName?.name ? departamentName?.name : "-"
            }}</span>
        </p>
      </div>
    </article>
    <article class="col-12">
      <div class="shadow-2 p-4 border-round-sm">
        <span class="titleSection font-bold text-base mt- mb-2">{{
          claim?.rol == "Representante gremial"
          ? "Datos de reclamado"
          : "Dato de reclamante"
          }}</span><br />
        <div class="grid mt-2">
          <div class="col-6 md:col-3">
            <p>Razón Social</p>
            <p class="bold">
              {{ claim?.razonSocial ? claim?.razonSocial : "-" }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>CUIT</p>
            <p class="bold">
              {{ claim?.companyCuit ? claim?.companyCuit : "-" }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>Correo electrónico</p>
            <p class="bold">
              {{ claim?.companyEmail ? claim?.companyEmail : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Teléfono</p>
            <p class="bold">
              {{ claim?.companyPhone ? claim?.companyPhone : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Calle</p>
            <p class="bold">
              {{ claim?.streetCompany ? claim?.streetCompany : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Número</p>
            <p class="bold">
              {{ claim?.numberCompany ? claim?.numberCompany : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Piso/Depto</p>
            <p class="bold">
              {{
              claim?.floorApartmentCompany
              ? claim?.floorApartmentCompany
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Torre</p>
            <p class="bold">
              {{ claim?.towerCompany ? claim?.towerCompany : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Código postal</p>
            <p class="bold">
              {{ claim?.postalCodeCompany ? claim?.postalCodeCompany : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Provincia</p>
            <p class="bold">
              {{ claimetProvince?.name ? claimetProvince?.name : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Localidad</p>
            <p class="bold">
              {{ claim?.cityCompany ? claim?.cityCompany : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Persona</p>
            <p class="bold">
              {{
              claim?.rol == "Representante gremial"
              ? claim?.type_of_person
              ? claim?.type_of_person
              : "-"
              : claim?.claimantTypePerformance
              ? claim?.claimantTypePerformance
              : "-"
              }}
            </p>
          </div>
        </div>
        <div class="col-12 ml-0 pl-0" *ngIf="claim?.rol == 'Empleador'">
          <p>Documentos</p>
          <div class="gap-2 flex mt-2 extra-doc-container">
            <div class="pdf-item flex align-items-center justify-content-between" *ngFor="let file of files">
              <div class="pdf-info flex align-items-center">
                <i class="pi pi-file-pdf"></i>
                <span class="bold mt-0">{{ file }}</span>
              </div>
              <div class="pdf-actions">
                <button (click)="viewImage(file)" title="Ver PDF">
                  <i class="pi pi-eye"></i>
                </button>
                <button title="Descargar PDF" (click)="downloadPdf(file)">
                  <i class="pi pi-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article class="col-12" *ngIf="
        claim?.rol == 'Empleador' &&
        claim?.claimantTypePerformance == 'Persona jurídica'
      ">
      <div class="shadow-2 p-4 border-round-sm">
        <span class="titleSection font-bold text-base mt- mb-2">Datos personales</span><br />
        <div class="grid mt-2">
          <div class="col-6 md:col-3">
            <p>Apellido/s</p>
            <p class="bold">
              {{ claim?.lastName ? claim?.lastName : " " }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Nombre/s</p>
            <p class="bold">
              {{ claim?.name ? claim?.name : "-" }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>Cuil</p>
            <p class="bold">
              {{ claim?.cuil ? claim?.cuil : "-" }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>Cargo que ocupa en la empresa</p>
            <p class="bold">
              {{ claim?.claimantPosition ? claim?.claimantPosition : "-" }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>Correo electrónico</p>
            <p class="bold">
              {{ claim?.email ? claim?.email : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Teléfono</p>
            <p class="bold">
              {{ claim?.phone ? claim?.phone : "-" }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Fecha de Nacimiento</p>
            <p class="bold">
              {{
              claim?.birthday ? (claim?.birthday | date : "dd/MM/yyyy") : "-"
              }}
            </p>
          </div>
        </div>
      </div>
    </article>
    <article class="col-12" *ngIf="claim?.rol == 'Representante gremial'">
      <div class="shadow-2 p-4 border-round-sm">
        <span class="titleSection font-bold text-base mt- mb-2">Dato de reclamante</span><br />
        <div class="grid mt-2">
          <div class="col-6 md:col-3">
            <p>Nombre y apellido</p>
            <p class="bold">
              {{
              claim?.representative_last_name
              ? claim?.representative_name +
              " " +
              claim?.representative_last_name
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Cargo</p>
            <p class="bold">
              {{
              claim?.claimantTypePerformance
              ? claim?.claimantTypePerformance
              : "-"
              }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>CUIT</p>
            <p class="bold">
              {{
              claim?.representative_cuil ? claim?.representative_cuil : "-"
              }}
            </p>
          </div>
          <div class="col-12 md:col-3">
            <p>Correo electrónico</p>
            <p class="bold">
              {{
              claim?.representative_email ? claim?.representative_email : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Teléfono</p>
            <p class="bold">
              {{
              claim?.representative_phone ? claim?.representative_phone : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Calle</p>
            <p class="bold">
              {{
              claim?.representative_street
              ? claim?.representative_street
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Número</p>
            <p class="bold">
              {{
              claim?.representative_number
              ? claim?.representative_number
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Piso/Depto</p>
            <p class="bold">
              {{
              claim?.representative_floor_apartment
              ? claim?.representative_floor_apartment
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Torre</p>
            <p class="bold">
              {{
              claim?.representative_tower ? claim?.representative_tower : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Código postal</p>
            <p class="bold">
              {{
              claim?.representative_postal_code
              ? claim?.representative_postal_code
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Provincia</p>
            <p class="bold">
              {{
              claim?.representative_province
              ? claim?.representative_province
              : "-"
              }}
            </p>
          </div>
          <div class="col-6 md:col-3">
            <p>Localidad</p>
            <p class="bold">
              {{
              claim?.representative_city ? claim?.representative_city : "-"
              }}
            </p>
          </div>
        </div>
        <hr class="mb-2" />
        <div class="col-12 ml-0 pl-0">
          <p>Documentos</p>
          <div class="gap-2 flex mt-2 extra-doc-container">
            <div class="pdf-item flex align-items-center justify-content-between" *ngFor="let file of files">
              <div class="pdf-info flex align-items-center">
                <i class="pi pi-file-pdf"></i>
                <span class="bold mt-0">{{ file }}</span>
              </div>
              <div class="pdf-actions">
                <button (click)="viewImage(file)" title="Ver PDF">
                  <i class="pi pi-eye"></i>
                </button>
                <button title="Descargar PDF" (click)="downloadPdf(file)">
                  <i class="pi pi-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article class="col-12">
      <div class="shadow-2 p-4 border-round-sm">
        <span class="titleSection font-bold text-base mt- mb-2">{{
          claim?.rol == "Representante gremial"
          ? "Datos de representados"
          : "Dato de reclamados"
          }}</span>
        <div class="mt-3">
          <p-table id="table" [value]="claim!.employees" *ngIf="claim!.employees?.length" scrollable="true"
            [ngClass]="{ 'scroll-table': enableScroll }">
            <ng-template pTemplate="header">
              <tr>
                <th>Apellido y Nombre</th>
                <th>CUIL</th>
                <th>Correo Electronico</th>
                <th>Domicilio</th>
                <th>Código Postal</th>
                <th>Provincia</th>
                <th>Localidad</th>
                <th>DNI frente y dorso</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-worker>
              <tr>
                <td [title]="worker.nameClaimed">
                  {{ worker.nameClaimed | truncate }}
                </td>
                <td>{{ worker.claimedCuil }}</td>
                <td [title]="worker.claimedEmail">
                  {{ worker.claimedEmail | truncate }}
                </td>
                <td>
                  {{ worker.claimedStreet }}
                  {{ worker.claimedNumber | truncate }}
                </td>
                <td>{{ worker.claimedPostalCode }}</td>
                <td>{{ getProvinceName(worker.claimedProvince) }}</td>
                <td>{{ worker.claimedCity }}</td>
                <td class="text-center cursor-pointer" title="Ver DNI">
                  <img *ngFor="let dniImage of worker.claimedDni" (click)="showDialog(dniImage)"
                    src="../../../../../../assets/img/main/icon-pdf.svg" class="dni-image"
                    style="max-width: 30px; margin-right: 5px" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </article>

    <article class="col-12">
      <div class="shadow-2 p-4 border-round-sm">
        <div class="grid mt-2">
          <div class="col-10">
            <span class="titleSection font-bold text-base mt-2 mb-2">Motivos del conflicto</span>
          </div>
          <div class="col-6">
            <p>Objeto del reclamo</p>
            <div *ngFor="let item of claim?.selecterObjectOfClaim">
              <p class="bold">
                {{ item }}
              </p>
            </div>
          </div>
          <div class="col-6 detail-claim">
            <p>Modalidad de Presentación del Reclamo</p>
            <p class="bold">
              {{ claim?.selectedOwnRight ? claim?.selectedOwnRight : "-" }}
            </p>
          </div>
          <div class="col-12">
            <p>Detalle del relamo</p>

            <p class="bold">
              {{
              claim?.textClaimDetails
              ? claim?.textClaimDetails
              : "No se ha ingresado detalle del reclamo"
              }}
            </p>
          </div>
        </div>

        <div *ngIf="claim?.lawyerFullName">
          <hr class="mb-3" />
          <span class="titleSection font-bold text-base mt-2 mb-2">Representación letrada</span>
          <div class="grid mt-2">
            <div class="col-6 md:col-3">
              <p>Apellido y Nombre</p>
              <p class="bold">
                {{ claim?.lawyerFullName ? claim?.lawyerFullName : "-" }}
              </p>
            </div>
            <div class="col-6 md:col-3">
              <p>Matrícula</p>
              <p class="bold">
                {{
                claim?.lawyerRegistrationNumber
                ? claim?.lawyerRegistrationNumber
                : "-"
                }}
              </p>
            </div>
            <div class="col-6 md:col-3">
              <p>Correo electrónico</p>
              <p class="bold">
                {{ claim?.lawyerEmail ? claim?.lawyerEmail : "-" }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="extrafiles">
          <hr class="mb-3" />
          <div class="col-12 ml-0 pl-0">
            <p>Documentación Externa</p>
            <div class="gap-2 flex mt-2 extra-doc-container">
              <div class="pdf-item flex align-items-center justify-content-between" *ngFor="let file of extrafiles">
                <div class="pdf-info flex align-items-center">
                  <i class="pi pi-file-pdf"></i>
                  <span class="bold mt-0">{{ file }}</span>
                </div>
                <div class="pdf-actions">
                  <button (click)="viewImage(file)" title="Ver PDF">
                    <i class="pi pi-eye"></i>
                  </button>
                  <button title="Descargar PDF" (click)="downloadPdf(file)">
                    <i class="pi pi-download"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article class="col-12">
      <div class="shadow-2 p-4 border-round-sm">
        <span class="titleSection font-bold text-base mt-2 mb-4">Historial de audiencias</span>
        <ng-container *ngIf="minutesForClaim?.length; else elseTemplate">
          <p class="mt-2 ml-4 font-bold">Fecha</p>
          <div class="gap-2 flex mt-2 flex flex-column">
            <div class="flex col-12 align-items-center justify-content-between" *ngFor="let pdf of minutesForClaim">
              <div class="pdf-info flex align-items-center col-6">
                <p>{{ pdf.date | date : "dd-MM-yyyy" }}</p>
                <i class="pi pi-file-pdf ml-8"></i>
                <span class="bold mt-0">{{ pdf.fileActa }}</span>
              </div>
              <div class="pdf-actions">
                <button title="Ver PDF" (click)="viewMinutePdf(pdf.id, pdf.fileActa)">
                  <i class="pi pi-eye"></i>
                </button>
                <button title="Descargar PDF" (click)="downloadPdf(pdf.fileActa, pdf.id)">
                  <i class="pi pi-download"></i>
                </button>
                <button
                  *ngIf="userRol === 'Administrador' || (userRol === 'Conciliador' && claim?.status !== 'Finalizado')"
                  title="Eliminar acta"
                  (click)="deleteActa(pdf.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <p class="mt-2 ml-4 font-bold">No hay actas registradas</p>
        </ng-template>
      </div>
    </article>
  </section>
  <app-spinner-load [isLoading]="isLoading"></app-spinner-load>
  <div *ngIf="
      !buttons ||
      claim?.status === 'Finalizado' ||
      claim?.status === 'Rechazado' ||
      claim?.status === 'Borrador'
    ">
    <div class="grid w-full flex justify-content-end mt-3">
      <div class="col-6 md:col-3 lg:col-3 xl:col-3">
        <p-button (click)="goBack()" label="Volver" class="btn-cancelar sm:text-xs" />
      </div>
    </div>
  </div>
  <app-action-buttons [buttons]="buttons" [claim]="claim" [rol]="userRol" (goBackEvent)="goBack()"
    (acceptRejectEvent)="recibeAceptDialog($event)" (newAudienceEvent)="newAudienceCheck()"
    (newMinuteEvent)="newMinuteCheck()"></app-action-buttons>
</section>

<!-- DIALOGS -->
<p-dialog header="Visualizador" [(visible)]="showFileDialog" [modal]="true" [style]="{ width: '50vw', height: '60vh' }"
  [draggable]="false" [resizable]="false" (onHide)="onHide()">
  <div class="h-full">
    <iframe [src]="urlFile | safeResourceUrl" class="w-full h-full" style="border: none"></iframe>
  </div>
</p-dialog>

<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message class="congirmDialog">
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <span class="labelTitle1 text-lg font-semibold mb-1">
        {{ message.header }}
      </span>
      <div class="flex justify-content-center align-items-center gap-2">
        <i class="pi pi-exclamation-circle"></i>
        <p class="text-base">{{ message.message }}</p>
      </div>
      <div class="flex flex-row justify-content-center align-items-center gap-2 mt-3">
        <ng-container class="col-12">
          <button pButton label="Cancelar" (click)="cd.reject()" class="btn-cancelar col-6" style="
              border: 1px solid #263245;
              background-color: white;
              color: #263245;
              font-size: 0.8rem;
            "></button>
          <button pButton [label]="labelText" (click)="cd.accept()" class="btn-siguiente col-6 popup" style="
              background-color: #263245;
              border-color: #263245;
              color: white !important;
              font-size: 0.8rem;
            "></button>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-dialog header="Rechazar reclamo" [(visible)]="rejectDialogVisible" [modal]="true" [closable]="false">
  <div class="p-fluid">
    <div class="p-field flex flex-column">
      <label class="font-semibold text-title" for="reason">Motivo de rechazo</label>
      <input placeholder="Escriba aqui el motivo de rechazo del reclamo" id="reason" [(ngModel)]="rejectionReason"
        rows="5" class="inputtarea" />
    </div>
    <div class="p-field flex flex-column mt-3">
      <label class="font-semibold text-title" for="rejectionFile">Archivo de rechazo (PDF opcional)</label>
      <div class="col-12 mt-2 pl-0">
        <div class="dropzone-container h-6rem col-12">
          <input #rejectionFileInput accept=".pdf" id="rejectionFile" type="file"
            (change)="onRejectionFileUpload($event)" [disabled]="!!rejectionFileBase64" />
          <div class="w-full flex align-items-center justify-content-between col-12">
            <img class="hidden md:block" src="../../../../../../assets/img/main/file-update.svg" />
            <span class="descriptionContent hidden md:block white-space-nowrap">Suba su documento aquí</span>
            <p-button pRipple (click)="rejectionFileInput.click()" class="btnUploadFile mr-1" [disabled]="!!rejectionFileBase64">Elegir archivo</p-button>
          </div>
        </div>
        <span class="descriptionContent mt-2">Archivos permitidos: PDF</span>
      </div>
      <div class="col-12 pl-0 mt-2" *ngIf="rejectionFileBase64">
        <div class="imageContainer">
          <img src="../../../../../../assets/img/main/icon-pdf.svg" alt="PDF" class="icon-imagen" />
          <span class="descriptionContent">Archivo cargado exitosamente</span>
          <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger"
            (click)="removeRejectionFile(rejectionFileInput)"></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-content-end gap-2">
    <button pButton label="Cancelar" (click)="rejectDialogVisible = false" (click)="rejectionReason = ''"
      class="btn-cancelar" style="
        border: 1px solid #263245;
        background-color: white;
        color: #263245;
        font-size: 0.8rem;
      "></button>
    <button pButton label="Rechazar reclamo" (click)="confirmRejection()"
      (acceptRejectEvent)="recibeAceptDialog($event)" (newAudienceEvent)="newAudienceCheck()"></button>
  </div>
</p-dialog>

<p-dialog header="Fijar Audiencia" [(visible)]="audienciaDialogVisible" [modal]="true" [closable]="false"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: 'auto' }">
  <app-audience (closePopup)="cancel($event)" [claim]="claimForAudience"
    (showMessage)="handleShowMessage($event)"></app-audience>
</p-dialog>

<p-dialog header="Subir acta" [(visible)]="minuteDialogVisible" [modal]="true" [closable]="false">
  <app-minute (closePopup)="cancel($event)" [claimId]="claimId" [audienceId]="claim?.audience_id"
    (showMessage)="handleShowMessage($event)"></app-minute>
</p-dialog>

<div>
  <p-dialog header="Tipo de intimación" [(visible)]="typeAdmitedClaimDialogVisible"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: 'auto' }" [modal]="true" [closable]="true"
    [draggable]="false">
    <app-admit-claim (resultIntimationEvent)="resultIntimationAdmitedEvent($event)"
      (resultTypeEvent)="resultTypeAdmitedEvent($event)"></app-admit-claim>
  </p-dialog>
</div>

<p-toast />

<app-spinner-load [isLoading]="isLoading"></app-spinner-load>